export default "__VITE_ASSET__DFqlu5Zn__"